import React from 'react';

interface AllStats {
  totalGuests: number;
  totalResponded: number;
  totalAttending: number;
}

interface EventStats {
  totalInvited: number;
  totalYes: number;
  totalNo: number;
  totalPending: number;
}

interface StatisticsCardsProps {
  isFiltered: boolean;
  allStats?: AllStats;
  eventStats?: EventStats;
}

const StatisticsCards: React.FC<StatisticsCardsProps> = ({
  isFiltered,
  allStats,
  eventStats,
}) => {
  return (
    <section className="stats-grid">
      {!isFiltered && allStats ? (
        <>
          <div className="stat-card">
            <div className="stat-value">{allStats.totalGuests}</div>
            <div className="stat-label">Invités</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{allStats.totalResponded}</div>
            <div className="stat-label">Ont répondu</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{allStats.totalAttending}</div>
            <div className="stat-label">Confirmés</div>
          </div>
        </>
      ) : eventStats ? (
        <>
          <div className="stat-card">
            <div className="stat-value">{eventStats.totalInvited}</div>
            <div className="stat-label">Invités</div>
          </div>
          <div className="stat-card accent-green">
            <div className="stat-value">{eventStats.totalYes}</div>
            <div className="stat-label">Oui</div>
          </div>
          <div className="stat-card accent-red">
            <div className="stat-value">{eventStats.totalNo}</div>
            <div className="stat-label">Non</div>
          </div>
          <div className="stat-card accent-orange">
            <div className="stat-value">{eventStats.totalPending}</div>
            <div className="stat-label">En attente</div>
          </div>
        </>
      ) : null}
    </section>
  );
};

export default StatisticsCards;
